import { useBackgroundTaskStatus } from '../../../../data/batchstatus/hooks'
import { BackgroundTaskStatusDialog } from './BackgroundTaskStatus'

interface Props {
  visible: boolean
  isDelete: boolean
  isCreate: boolean
  isSupplierProcess?: boolean
  locationUrl: string
  retry?: string
  onHide: () => void
  mutate: () => void
}

export const BackgroundTaskStatusContainer: React.FC<Props> = ({
  mutate,
  locationUrl,
  retry,
  onHide,
  visible,
  isCreate,
  isDelete,
  isSupplierProcess,
}) => {
  //const { data: status } = useBackgroundTaskStatus(locationUrl)

  return (
    <BackgroundTaskStatusDialog
      onHide={onHide}
      visible={visible}
      locationUrl={locationUrl}
      isCreate={isCreate}
      isDelete={isDelete}
      retry={retry}
      isSupplierProcess={isSupplierProcess ? isSupplierProcess : false}
      mutate={mutate}
    />
  )
}
